// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMessageCircleMore as RawLucideMessageCircleMore } from "lucide-react";
export const LucideMessageCircleMore = /* @__PURE__ */ createIcon(RawLucideMessageCircleMore, "LucideMessageCircleMore", 2);
